import React, { useState, useEffect, useRef } from "react";

import { Table, Tooltip, Tag, Input, Button, Space, message } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { getPackageData } from "../../../Redux/actions/packageActions";

const Index = ({
  columns,
  mainSearch,
  ChangedSelected,
  rowClick,
  resetTable,
  fetchTable,
  apiurl,
  token,
  expandTable,
  expandRenderer,
  expandIndicator,
  extraController,
  showEditColumn,
  allowRowSelection,
  packageStatus,
}) => {
  const dispatch = useDispatch();

  const { crudData, crudDataCount } = useSelector(
    (state) => ({
      crudData: state.packages.data,
      crudDataCount: state.packages.dataCount,
    }),
    shallowEqual
  );
  const [data, setData] = useState([]);
  const [sorter, setSorter] = useState(null);
  const [filterArray, setFilterArray] = useState([]);
  const [filterText, setFilterText] = useState(null);
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [defaultpageSize, setDefaultPageSize] = useState(50);
  const [range, setRange] = useState([1, 50]);
  const [pageSizeOptions, setPageSizeOptions] = useState([75, 100, 500, 1000]);

  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedSKU, setSelectedSKU] = useState(null);
  const searchInput = useRef(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [formattedColumns, setFormattedColumns] = useState([]);

  useEffect(() => {
    getTableData(defaultpageSize, 0, null, null, null);
    var requestData = {
      apiurl: apiurl,
      mode: "refresh",
      packageStatus: packageStatus,
    };
    dispatch(getPackageData(requestData));
  }, []);

  useEffect(() => {
    setSelectedRowKeys([]);
  }, [extraController]);

  useEffect(() => {
    getTableData(defaultpageSize, 0, null, filters, searchText);
  }, [filterArray]);

  const getTableData = (limit, offset, sort, filter, search) => {
    setLoading(true);
    var limitoffset = `?limit=${limit}&offset=${offset}`;
    var controllerText = limitoffset;
    var searchText = "";

    // if(search !== null){
    //   requestData['searchText'] = search
    // }
    // console.log(filterArray)
    // if(filterArray.length > 0){
    //   requestData['filters'] = filterArray
    // }

    // var sortText =''
    // if(sort !== null){
    //     sortText = sort
    //     controllerText =controllerText +sortText
    // }

    // if(extraController){
    //   controllerText =controllerText +extraController
    // }

    // dispatch(getPackageData(requestData))
  };

  useEffect(() => {
    setData(crudData);
    setLoading(false);
    console.log(crudData);
  }, [crudData]);

  useEffect(() => {
    var newColumns = columns.map((item) => {
      if (item.search) {
        var newItem = {
          ...item,
          ...getColumnSearchProps(item.search),
        };
        return newItem;
      } else {
        return item;
      }
    });
    setFormattedColumns(newColumns);
  }, [columns]);

  useEffect(() => {
    if (mainSearch && data) {
      onSearch(mainSearch);
    }
  }, [mainSearch]);

  const onSearch = (value) => {
    var searchval = value.toString();
    setSearchText(searchval);
    setPage(1);
    if (searchval) {
      getTableData(defaultpageSize, 0, null, null, searchval);
    } else {
      getTableData(defaultpageSize, 0, null, filters, null);
    }
  };

  const handleTableChange = (pagination, filters, sorter1) => {
    handleSorter(sorter1);
  };

  const handleSorter = (sorter1) => {
    if (sorter !== sorter1) {
      var sorterValue = null;
      ////console.log(sorter)
      if (sorter1.order === "ascend") {
        ////console.log('ASC',sorter.columnKey )
        sorterValue = `&ordering=${sorter1.columnKey}`;
        setSorter(sorterValue);
        getTableData(pageSize, offset, sorterValue, filters, searchText);
      } else if (sorter1.order === "descend") {
        ////console.log('DCS',sorter.columnKey)
        sorterValue = `&ordering=-${sorter1.columnKey}`;
        setSorter(sorterValue);
        getTableData(pageSize, offset, sorterValue, filters, searchText);
      } else if (sorter1.order === undefined) {
        sorterValue = null;
        setSorter(sorterValue);
      }
    }
  };

  useEffect(() => {
    ChangedSelected(selectedRowKeys);
  }, [selectedRowKeys]);

  useEffect(() => {
    handleresetTable();
    var requestData = {
      apiurl: apiurl,
      mode: "refresh",
      packageStatus: packageStatus,
    };
    dispatch(getPackageData(requestData));
  }, [resetTable, packageStatus]);

  useEffect(() => {
    if (mainSearch) {
      setSearchText(mainSearch);
    } else {
      getTableData(defaultpageSize, 0, null, null, null);
    }
  }, [fetchTable]);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible && searchInput) {
        setTimeout(
          () => searchInput.current && searchInput.current.select(),
          100
        );
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText, mainSearch, filterText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();

    addtoFilterArray(selectedKeys[0], dataIndex);
    setFilterText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    removeFilterArray(dataIndex);
    setFilterText("");
  };
  const generateFilterController = (currentArray) => {
    var filter = "";
    Object.entries(currentArray).map(([key, value]) => {
      filter = filter + `&${value.dataIndex}=${value.value}`;
    });
    setFilters(filter);
    // getTableData(defaultpageSize,0,null,filter,searchText)
  };

  const addtoFilterArray = (value, dataIndex) => {
    if (value) {
      var newItem = {
        value: value,
        dataIndex: dataIndex,
      };
      var i;
      for (i = 0; i < filterArray.length; i++) {
        if (filterArray[i]["dataIndex"] === dataIndex) {
          var newArray = [...filterArray];
          newArray[i] = newItem;
          setFilterArray(newArray);
          generateFilterController(newArray);
        }
      }
      setFilterArray(filterArray.concat(newItem));
      generateFilterController(filterArray.concat(newItem));
    }
  };

  const removeFilterArray = (dataIndex) => {
    var i;
    for (i = 0; i < filterArray.length; i++) {
      if (filterArray[i]["dataIndex"] === dataIndex) {
        var newArray = [...filterArray];
        newArray.splice(i, 1);
        setFilterArray(newArray);
        generateFilterController(newArray);
      }
    }

    generateFilterController(filterArray);
  };

  const handleresetTable = () => {
    getTableData(defaultpageSize, 0, null, null, null);

    setDefaultPageSize(defaultpageSize);
    setPageSize(50);
    setRange([1, 50]);
    setPage(1);
    setSearchText(null);
    setFilterArray([]);
    setFilterText(null);
    setFilters(null);
    setSorter(null);
    setOffset(0);
    setLoading(true);
  };

  const onChangePage = (page1, pageSize1) => {
    if (loading == false) {
      setPage(page1);
    }
  };

  const onChangePageSize = (currentPage1, pageSize1) => {
    if (pageSize !== pageSize1 && loading == false) {
      setPageSize(pageSize1);
      setPage(1);
      setOffset(1);
      getTableData(pageSize1, 0, sorter, filters, searchText);
    }
  };

  const onChangeRange = (total1, range1) => {
    if (range[0] !== range1[0] || range[1] !== range1[1]) {
      var offset = range[0] - 1;
      setRange(range1);
      getTableData(pageSize, offset, sorter, filters, searchText);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (e) => {
      setSelectedRowKeys(e);
    },
  };

  const onRowClick = (val) => {
    rowClick(val);
  };

  const columnfilter = () => {
    var filteredColumn = formattedColumns;

    const editpart = [
      {
        title: "Edit",
        width: 50,
        render: (text, record, index) => {
          return (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onRowClick(record);
              }}
            >
              <EditOutlined />
            </div>
          );
        },
      },
    ];
    if (showEditColumn) {
      filteredColumn = filteredColumn.concat(editpart);
    }

    return filteredColumn;
  };

  return (
    <Table
      className={"table"}
      columns={columnfilter()}
      dataSource={data}
      sorter={true}
      expandable={
        expandTable
          ? {
              expandedRowRender: (record) => {
                return expandRenderer(record);
              },
              rowExpandable: (record) => record[expandIndicator],
            }
          : undefined
      }
      // pagination={ {
      //   onChange: (page, pageSize) => {onChangePage(page, pageSize)},
      //   showTotal: (total, range)	=> {onChangeRange(total, range)},
      //   onShowSizeChange:(current, size)=>{onChangePageSize(current, size)},
      //   current: page,
      //   showQuickJumper:true,
      //   defaultPageSize:defaultpageSize,
      //   pageSizeOptions:pageSizeOptions,
      //   showSizeChanger:true,
      //   total:crudDataCount }
      // }
      rowKey="id"
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            if (!showEditColumn) {
              onRowClick(record);
            }
          }, // click row
        };
      }}
      onChange={handleTableChange}
      rowSelection={allowRowSelection ? rowSelection : false}
    />
  );
};

export default Index;
